import React from 'react';
import { useIntl } from 'react-intl';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';

import CmsElementQuestionnaireForm from 'components/cms/elements/CmsElementQuestionnaireForm';

function CmsElementQuestionnaire(props) {
  const { editMode, index, showElementSettings } = props;

  // Intl Hook für stabile Messages
  const intl = useIntl();
  const messages = intl?.messages || {};

  // CMS Logic Hook
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getBackgroundStyle,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // Styles & Logik
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  const isVisible = editMode || shown;
  const shownClass = isVisible ? 'elem-shown' : 'elem-hidden';
  const mainColorClass = `text-${getParamValue('mainColor', 'master')}`;

  const questionnaireId = getParamValue('questionnaireId');
  const pipelineId = getParamValue('pipelineId');
  const buttonTitle = getParamValue('buttonTitle');
  const parallaxData = getParallaxData();

  const innerContent = (
    <div
      id={getMainId()}
      className={`ms-questionnaire-content ${shownClass} ${mainColorClass} ${cssClasses} ${responsiveClasses}`.trim()}
      onClick={(e) => editMode && showElementSettings(e, index)}
      style={getBackgroundStyle()}
    >
      {elementStyleTag}

      {questionnaireId ? (
        <>
          <h4 className={`no-margin p-b-5 ${mainColorClass}`}>{getParamValue('title', messages.questionnaire)}</h4>

          <CmsElementQuestionnaireForm
            questionnaireId={questionnaireId}
            pipelineId={pipelineId}
            mainColorClass={mainColorClass}
            buttonTitle={buttonTitle}
          />
        </>
      ) : (
        <div className="p-t-15 p-b-15 text-center">
          <i className="fal fa-envelope-open-text fa-4x" />
          {editMode && <p className="small m-t-10">Bitte Questionnaire ID in den Einstellungen wählen</p>}
        </div>
      )}

      {getAppendHtml()}
    </div>
  );

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementQuestionnaire;
